import { createAsyncThunk } from '@reduxjs/toolkit'
import { handleExport } from '../../../../../../helpers/export'
import FinancialAnalysisService from '../../../core/service'

export const getAssetManagementEfficiencyThunk = createAsyncThunk(
  'financialAnalysis/GET_ASSET_MANAGEMENT_EFFICIENCY',
  async (data, { rejectWithValue }) => {
    const response =
      await FinancialAnalysisService.getAssetManagementEfficiency(data)
    if (response.success) {
      return response.data
    }
    return rejectWithValue(response.errors)
  },
)

export const downloadAssetManagementEfficiencyThunk = createAsyncThunk(
  'financialAnalysis/DOWNLOAD_PROFITABILITY',
  async (data) => {
    const response =
      await FinancialAnalysisService.downloadAssetManagementEfficiency(data)
    handleExport(response.data, response.filename)
  },
)
